import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';

import { CustomTooltip } from 'ui';
import { theme } from 'theme';
import makeStyles from '@mui/styles/makeStyles';
import { parseScoreToString } from 'shared/parsers/esg';

const useStyles = makeStyles(() => ({
  svgCircle: {
    pointerEvents: 'none',
  },
  tooltipScore: {
    textTransform: 'capitalize',
  },
}));

const ESGImpactIcon = ({
  name,
  impactWeight,
  impactNumber,
  hoveredContinent,
  tooltip,
  className,
}) => {
  const classes = useStyles();
  const classNames = clsx(classes.svgCircle, className);
  if (!impactWeight) return null;

  const renderIcon = (
    <svg height="32" width="32" className={classNames}>
      <circle cx="16" cy="16" r="7" fill={theme.palette.custom.black} />
      {['average', 'high'].includes(impactWeight) && (
        <circle
          cx="16"
          cy="16"
          r="12"
          strokeWidth="1"
          fill="none"
          stroke={theme.palette.custom.black}
        />
      )}
      {impactWeight === 'high' && (
        <circle
          cx="16"
          cy="16"
          r="13"
          strokeWidth="5"
          fill="none"
          stroke={theme.palette.custom.black}
        />
      )}
    </svg>
  );

  return tooltip ? (
    <CustomTooltip
      placement="top"
      title={
        <>
          <Typography color="primary">{name}</Typography>
          <Typography className={classes.tooltipScore}>
            {`Score: ${parseScoreToString(impactNumber)}`}
          </Typography>
          <Typography className={classes.tooltipScore}>{`Weight: ${impactWeight}`}</Typography>
        </>
      }
      open={hoveredContinent === name}
      arrow
    >
      {renderIcon}
    </CustomTooltip>
  ) : (
    renderIcon
  );
};

ESGImpactIcon.defaultProps = {
  name: null,
  impactWeight: null,
  impactNumber: null,
  hoveredContinent: null,
  tooltip: false,
  className: undefined,
};

ESGImpactIcon.propTypes = {
  name: PropTypes.string,
  impactWeight: PropTypes.oneOf(['low', 'average', 'high']),
  impactNumber: PropTypes.number,
  hoveredContinent: PropTypes.string,
  tooltip: PropTypes.bool,
  className: PropTypes.string,
};

export default ESGImpactIcon;
